import { combineReducers } from 'redux';

import { reducer as email } from './State/email';

export default combineReducers({
  email
})
